import { render, staticRenderFns } from "./SidebarUserStatus.vue?vue&type=template&id=c569cd06"
import script from "./SidebarUserStatus.vue?vue&type=script&lang=js"
export * from "./SidebarUserStatus.vue?vue&type=script&lang=js"
import style0 from "./SidebarUserStatus.vue?vue&type=style&index=0&id=c569cd06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports